<template>
    <el-container class="errorpage" style="height:100vh">
        <el-main>    
            <el-row type="flex" align="middle" justify="center">
                <h1>404</h1>
                <p>Not found. Please check the URL and try again.</p>
            </el-row>
        </el-main>
    </el-container>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
    .errorpage{
        color:white;
        font-size:16px;
        background: url('../../public/cert-pattern_v-03.svg') repeat, linear-gradient(45deg, #005778 0%,#0087bc 100%); 
        background-blend-mode: overlay;
        
        h1{
            font-size:8rem;
            	margin: 1rem 0;
        }

        .el-row{
            flex-flow:column nowrap;
        }
    }

</style>
